import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './client-provider/auth.guard';
import { CompaniesComponent } from './modules/companies/companies.component';
import { LicensesComponent } from './modules/licenses/licenses.component';
import { LoginComponent } from './modules/login/login.component';
import { PanelComponent } from './modules/panel/panel.component';

const childRouters: Routes = [
]

const routes: Routes = [
  { path: '', component: LoginComponent },
  
  {
    path: 'panel',
    loadChildren: () => import('../app/modules/panel/panel.module').then(m => m.PanelModule),
   },
  // { path: 'panel', component: PanelComponent, children: childRouters, outlet: 'panelRouter' },
  // { path: 'licenses', component: LicensesComponent },
  // { path: 'companies', component: CompaniesComponent },
];

@NgModule({
  providers: [],
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
